<template>
  <!-- DETAIL ZARIZENI -->
  <div class="detail-page">
    <div v-if="device" :class="{ visible: isHeaderFixed }" class="detail-page__sticky-header d-flex align-items-center">
      <div class="detail-page__sticky-header__left d-flex align-items-center">
        <strong class="detail-page__sticky-header__name">
          {{ $filters.strLimit(device.custDeviceName, 8) }}
        </strong>
        <DeviceStatusIcon :device="device" />
        {{ $t("pred") }}
        {{ $filters.beforeTime(device.lastMessageIn, "short") }}
      </div>
      <div class="detail-page__sticky-header__right d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-end detail-page__tabs__wrapper">
          <div :class="{ active: selectedTab === 1 }" class="detail-page__tabs__tab" @click="selectedTab = 1">
            {{ $t("routovaciSkupiny") }}
          </div>
          <div :class="{ active: selectedTab === 2 }" class="detail-page__tabs__tab" @click="selectedTab = 2">
            {{ $t("zpravy") }}
          </div>
          <!--div class="detail-page__tabs__tab" @click="selectedTab = 3" v-bind:class="{'active':(selectedTab == 3)}">{{ $t("logOperaci") }}</div-->
          <div :class="{ active: selectedTab === 4 }" class="detail-page__tabs__tab" @click="selectedTab = 4">
            {{ $t("vseOZarizeni") }}
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end detail-page__sticky-header__buttons">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleEditDeviceModal('editMqttDevice')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-edit.svg" />
            </div>
            {{ $t("upravit") }}
          </button>
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleMoveDeviceModal('moveDevice')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/icon_move.svg" />
            </div>
            {{ $t("MOVE_DEVICE_DETAIL") }}
          </button>
          {{ device.partnerId }}
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleSendMessageModal('sendMessage')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-send.svg" />
            </div>
            {{ $t("poslatZpravu") }}
          </button>
          <button
            class="btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0"
            @click="toggleDeleteDevice([device])"
          >
            <div class="atom-icon m-0">
              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
            </div>
          </button>
        </div>
      </div>
    </div>
    <div v-if="device" id="detail-header" class="layout__content__header layout__content__header--white">
      <AppBack :route="'/devices/mqtt/' + customerId + '/' + projectId" :text="'naSeznamZarizeni'" />
      <div class="d-flex justify-content-between">
        <h1 class="mb-0 layout__content__header__title">
          {{ device.custDeviceName }}
        </h1>
        <div class="layout__content__header__buttons d-none d-md-flex justify-content-end align-items-end">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleEditDeviceModal('editMqttDevice')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-edit.svg" />
            </div>
            {{ $t("upravit") }}
          </button>
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleMoveDeviceModal('moveDevice')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/icon_move.svg" />
            </div>
            {{ $t("MOVE_DEVICE_DETAIL") }}
          </button>
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleSendMessageModal('sendMessage')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-send.svg" />
            </div>
            {{ $t("poslatZpravu") }}
          </button>
          <button
            class="btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0"
            @click="toggleDeleteDevice([device])"
          >
            <div class="atom-icon m-0">
              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
            </div>
          </button>
        </div>
      </div>
      <DeviceStatusIcon :device="device" class="mb-3 mb-md-5" show-description />
      <div class="detail-page__info d-flex align-items-center font-weight-light">
        <span v-if="device" class="detail-page__info__item">
          {{ device.deviceId }}
        </span>
        <span class="detail-page__info__item">MQTT</span>
        <!--        <span class="detail-page__info__item" v-if="device.parameters">{{-->
        <!--          device.parameters.devicetype-->
        <!--        }}</span>-->
        <!--span class="detail-page__info__item gray-text-light">Je to na chodbě ve skříni</span-->
      </div>
      <div v-if="device" class="detail-page__boxes d-flex flex-column flex-md-row">
        <!-- SIGNAL RSSI STATUS -->
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $t("Poslední zpráva") }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <span v-if="device.lastMessageIn != null" class="font-weight-bolder">
              <span>
                {{ $t("pred") }}
                {{ $filters.beforeTime(device.lastMessageIn, "short") }}
              </span>
            </span>
            <span v-else>N/A</span>
          </div>
        </div>

        <!-- SERVICE BOX -->
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $filters.firstUpper($t("sluzba")) }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <div class="atom-icon justify-content-start">
              <img src="@/assets/icons/sluzba-check.svg" />
            </div>
            <span v-if="service" class="detail-page__boxes__item__textDashed">
              {{ service.custServiceName }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="device" class="detail-page__tags d-flex flex-column flex-sm-row font-weight-light align-items-start">
        <div v-if="visibleTags.length" class="d-flex flex-column flex-md-row detail-page__tags__tagRow">
          {{ $filters.firstUpper($t("tagy")) }}
          <div class="ml-md-2 mr-md-4 d-flex align-items-center flex-wrap">
            <TagBubbles :tag-list="device.tags" />
          </div>
        </div>
        <div
          v-if="Object.keys(visibleAttributes).length"
          class="d-flex flex-column flex-md-row mt-3 mt-sm-0 detail-page__tags__paramsRow"
        >
          {{ $filters.firstUpper($t("parametry")) }}
          <UserAttributesBubbles :attributes="device.attributes" />
        </div>
      </div>
      <div v-if="selectedTab == 1">
        <RadioHelp
          :article-link="'/mqtt-zarizeni/skupiny'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="selectedTab === 2">
        <RadioHelp
          :article-link="'/mqtt-zarizeni/zpravy'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="selectedTab === 4">
        <RadioHelp
          :article-link="'/mqtt-zarizeni/informace'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
    </div>

    <div class="layout__content__content pt-0 px-0">
      <div id="tabs" class="detail-page__tabs">
        <div class="detail-page__tabs__header d-flex">
          <div class="d-flex align-items-end detail-page__tabs__wrapper">
            <!-- TODO tohle bych renderoval v loop přes array z data() -->
            <div :class="{ active: selectedTab === 1 }" class="detail-page__tabs__tab" @click="selectedTab = 1">
              {{ $filters.firstUpper($t("routovaciSkupiny")) }}
            </div>
            <div
              :class="{ active: selectedTab === 2 }"
              class="detail-page__tabs__tab position-relative"
              @click="selectedTab = 2"
            >
              {{ $filters.firstUpper($t("zpravy")) }}
              <div v-if="suspendedMessagesCount" class="notification-icon">
                {{ suspendedMessagesCount }}
              </div>
            </div>
            <!--div class="detail-page__tabs__tab" @click="selectedTab = 3" v-bind:class="{'active':(selectedTab == 3)}">{{ $t("logOperaci") }}</div-->
            <div
              :class="{ active: selectedTab == 4 }"
              class="detail-page__tabs__tab position-relative"
              @click="selectedTab = 4"
            >
              {{ $filters.firstUpper($t("vseOZarizeni")) }}
              <div v-if="deviceInfoProblemCount" class="notification-icon">
                {{ deviceInfoProblemCount }}
              </div>
            </div>

            <RadioOpenClose
              :radio-slides="radioSlides"
              :show="showHelp"
              @update-show-radio-help="showRadioHelp($event)"
            />
          </div>
        </div>
        <div class="detail-page__tabs__content overflow-visible">
          <div v-if="selectedTab === 1">
            <DataFlowOverview
              v-if="device"
              :device="device"
              :groups="groups"
              :groups-endpoints="groupsEndpoints"
              :last-message-in="lastMessageIn"
              :transform-key="transformKey"
              device-type="mqtt"
              @edit-device="toggleEditDeviceModal('editMqttDevice')"
              @reload-device="loadDevice"
              @reload-groups="loadGroupEndpoints"
              @show-message="showMessage"
            />
          </div>
          <div v-if="selectedTab === 2" class="messages">
            <MqttMessages
              :device="device"
              :device-id="device.deviceId"
              :reload-d-m="reloadDM"
              @set-reload-d-m="setReloadDM"
              @show-message="showMessage"
              @toggle-send-message-modal="toggleSendMessageModal"
            />
          </div>
          <div v-if="selectedTab === 4">
            <div class="about">
              <div v-if="device" class="about__section">
                <div class="about__title">
                  <strong>
                    {{ $filters.firstUpper($t("informaceOZarizeni")) }}
                  </strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("nazevZarizeni")) }}
                    </div>
                    <div class="about__info__value">
                      {{ device.custDeviceName }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("Rezim")) }}
                    </div>
                    <div class="about__info__value">
                      <DeviceStatusIcon :device="device" show-description />
                    </div>
                  </div>
                  <!--div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $t("popis") }}
                    </div>
                    <div class="about__info__value">
                      Je to ve skříni na mezipatře.
                     </div>
                  </div-->

                  <div v-if="Object.keys(visibleAttributes).length">
                    <div v-for="(value, name) in visibleAttributes" :key="name">
                      <div class="about__info__row d-flex align-items-start">
                        <div class="about__info__label gray-text-light">
                          {{ name }}
                        </div>
                        <div class="about__info__value">
                          {{ value }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="visibleTags.length" class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("tagy")) }}
                    </div>
                    <div class="about__info__value">
                      <TagBubbles :tag-list="device.tags" />
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("Typ zařízení")) }}
                    </div>
                    <div class="about__info__value">MQTT</div>
                  </div>
                  <div v-if="transformationFunction" class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("TRANSFORMATION_FUNCTION")) }}
                    </div>
                    <div class="about__info__value">{{ transformationFunction.label }}</div>
                  </div>
                </div>
              </div>
              <div class="about__section">
                <div class="about__title">
                  <strong>
                    {{ $filters.firstUpper($t("zpravyZarizeni")) }}
                  </strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("posledniZpravaZeZarizeni")) }}
                    </div>
                    <div v-if="device.lastMessageIn" class="about__info__value" @click="showMessage(lastMessageIn)">
                      {{ $t("pred") }}
                      {{ $filters.beforeTime(device.lastMessageIn, "short") }}
                    </div>
                    <div v-else class="about__info__value">
                      {{ $t("neni") }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("PosledniZpravaDoZarizeni")) }}
                    </div>
                    <div class="about__info__value">
                      <span v-if="device.lastMessageOut" v-html="$filters.dateTime(device.lastMessageOut)" />
                      <div v-else>
                        {{ $t("neni") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__section">
                <div class="about__title">
                  <strong>
                    {{ $filters.firstUpper($t("sluzbaALimity")) }}
                  </strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("sluzba")) }}
                    </div>
                    <div v-if="service" class="about__info__value d-flex align-items-center">
                      <div>
                        {{ service.custServiceName }}
                        <br />
                        <small>{{ service.custServiceId }}</small>
                      </div>
                      <div
                        v-if="service.suspended"
                        v-tooltip
                        :title="$t('SERVICE_SUSPENDED')"
                        class="ml-4 d-flex align-items-center"
                      >
                        <span class="atom-circle atom-circle--danger">!</span>
                        <span class="ml-1 text-white bg-danger p-1 border-radius">
                          {{ $t("SUSPENDED") }}
                        </span>
                      </div>
                      <div
                        v-if="service.discontinued"
                        v-tooltip
                        :title="$t('SERVICE_DISCONTINUED')"
                        class="ml-4 d-flex align-items-center"
                      >
                        <span class="atom-circle atom-circle--danger">!</span>
                        <span class="ml-1 text-white bg-danger p-1 border-radius">
                          {{ $t("DISCONTINUED") }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__section">
                <div class="about__title">
                  <strong>
                    {{ $filters.firstUpper($t("IdentifikacniUdaje")) }}
                  </strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("identifikatorZarizeni")) }}
                    </div>
                    <div class="about__info__value">
                      {{ device.deviceId }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("mqttServer")) }}
                    </div>
                    <div class="about__info__value">mqtt.iot.cra.cz</div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("mqttPort")) }}
                    </div>
                    <div class="about__info__value">8883 SSL</div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("UZIVATELSKE_JMENO")) }}
                    </div>
                    <div class="about__info__value">
                      {{ $t("ZADANO_PRI_ZAKLADANI") }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("HESLO")) }}
                    </div>
                    <div class="about__info__value">
                      {{ $t("ZADANO_PRI_ZAKLADANI") }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("topicIn")) }}
                    </div>
                    <span
                      v-tooltip
                      :title="`publish ${customerId}.${projectId}.in.${device.deviceId}`"
                      class="detail-page__info__item"
                    >
                      publish {{ customerId }}.{{ projectId }}.in.{{ device.deviceId }}
                      <div
                        class="atom-copy d-flex align-items-center ml-2"
                        @click="copyToClipboard(`publish ${customerId}.${projectId}.in.${device.deviceId}`)"
                      >
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("topicOut")) }}
                    </div>
                    <span
                      v-tooltip
                      :title="`subscribe ${customerId}.${projectId}.out.${device.deviceId}`"
                      class="detail-page__info__item"
                    >
                      subscribe {{ customerId }}.{{ projectId }}.out.{{ device.deviceId }}
                      <div
                        class="atom-copy d-flex align-items-center ml-2"
                        @click="copyToClipboard(`subscribe ${customerId}.${projectId}.out.${device.deviceId}`)"
                      >
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <EditMqttDeviceModal
      v-if="openedEditDevice.length > 0"
      :device="device"
      :opened="openedEditDevice"
      @close-box="toggleEditDeviceModal"
      @open-box="toggleEditDeviceModal"
      @reload-items="loadDevice()"
      @transform-updated="handleTransformUpdated"
    />
    <MoveDeviceModal
      v-if="openedMoveDevice.length > 0"
      :devices="[device]"
      :opened="openedMoveDevice"
      @close-box="toggleMoveDeviceModal"
      @device-moved="handleDeviceMoved"
      @open-box="toggleMoveDeviceModal"
    />
    <DeleteDeviceModal
      :centered="true"
      :items="[device]"
      :opened="openedDeleteDevice"
      :text="deleteText"
      @close="toggleDeleteDevice()"
      @yes="
        () => {
          deleteDevice()
          toggleDeleteDevice()
        }
      "
    />
    <SendMqttMessageModal
      v-if="device"
      :device="device"
      :is-open="!!openedSendMessage.length"
      @close="toggleSendMessageModal"
      @open-box="toggleSendMessageModal"
      @reload-messages="setReloadDM"
    />

    <div v-if="device">
      <ShowMessage
        :device="device"
        :device-type="'MQTT'"
        :item="selectedMessage"
        :opened="openedMessageDetail"
        @close-box="toggleShowMessage"
      />
      <div v-if="errorsToTranslate.length">
        <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"

import Back from "@/components/back.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"

import MqttMessages from "@/components/devices/mqttMessages.vue"
import DataFlowOverview from "@/components/devices/partials/DataFlowOverview.vue"

import ShowMessage from "@/components/modals/devices/messageShow.vue"
import EditMqttDeviceModal from "@/components/modals/devices/editMqtt.vue"

import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import DeleteDeviceModal from "@/components/confirmations/delete.vue"
import MoveDeviceModal from "@/components/modals/devices/move.vue"
import { mapMutations, mapState } from "vuex"
import DeviceStatusIcon from "@/components/devices/partials/DeviceStatusIcon.vue"
import TagBubbles from "@/components/devices/tagBubbles.vue"
import UserAttributesBubbles from "@/components/devices/userAttributesBubbles.vue"
import { getVisibleAttributes, getVisibleTags } from "@/plugins/getVisible"
import SendMqttMessageModal from "@/components/modals/devices/sendMqttMessageModal.vue"
import { client } from "@/main"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"
import { useAuthStore } from "@/store/modules/auth"
import { useMqttStore } from "@/store/modules/devices/mqtt"

export default {
  components: {
    SendMqttMessageModal,
    DeviceStatusIcon,
    MoveDeviceModal,
    DeleteDeviceModal,
    DataFlowOverview,
    ShowMessage,
    EditMqttDeviceModal,
    "app-back": Back,
    MqttMessages,
    RadioHelp,
    RadioOpenClose,
    ErrorModal,
    TagBubbles,
    UserAttributesBubbles
  },
  props: {
    projectId: String,
    customerId: String
  },
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const authStore = useAuthStore()
    const mqttStore = useMqttStore()

    return { projectStore, configStore, authStore, mqttStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      selectedProjectId: this.$router.currentRoute.value.params.projectId,
      selectedCustomerId: this.$router.currentRoute.value.params.customerId,
      deviceId: this.$route.params.id,
      device: this.$route.params.device,
      props: {
        device: Object
      },
      groups: [],
      groupsEndpoints: [],
      signal: 2,
      selectedTab: 1,
      service: {},
      openedGroups: [],
      openedDropdown: false,
      isHeaderFixed: false,
      isTableHeaderFixed: false,
      sort: "%2Dcode",
      messages: [],
      openedMessageDetail: [],
      selectedMessage: {},
      lastMessageIn: {},
      lastMessageOut: {},
      openedDeleteDevice: false,
      deleteText: "",
      openedSendMessage: [],
      openedEditDevice: [],
      reloadDM: false,
      errorsToTranslate: [],
      openedError: false,
      allLogs: [],
      allMessages: [],
      articleLink: "",
      transformKey: "",
      openedMoveDevice: [],
      suspendedMessagesCount: false,
      transformationFunction: null
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    locale() {
      return this.$i18n.locale
    },
    project() {
      return this.projectStore.selectedProject
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    },
    apiUser() {
      return this.authStore.apiUser
    },
    deviceInfoProblemCount() {
      let count = 0
      if (this.device?.enabled && this.device?.suspended) {
        count++
      }
      if (this.device?.service?.suspended || this.device?.service?.discontinued) {
        count++
      }
      return count
    },
    visibleAttributes() {
      return getVisibleAttributes(this.device.attributes, this.apiUser?.isIotAdmin)
    },
    visibleTags() {
      return getVisibleTags(this.device.tags, this.apiUser?.isIotAdmin)
    }
  },
  watch: {
    radioDisabled: {
      handler() {
        this.showHelp = !this.radioDisabled
      },
      immediate: true
    }
  },
  mounted() {
    this.loadDevice()
    this.checkSuspendedMessages()

    const tabsElement = document.getElementById("tabs")
    window.document.onscroll = () => {
      if (tabsElement) {
        this.isHeaderFixed = window.scrollY > tabsElement.offsetTop + 250
      }
    }
  },
  unmounted() {
    window.document.onscroll = undefined
  },
  methods: {
    ...mapMutations({
      setNotification: "modals/setGlobalNotification",
      clearNotification: "modals/clearGlobalNotification"
    }),
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    async loadDevice() {
      var id = this.$route.params.id
      axios
        .get(process.env.VUE_APP_API + "/mqtt/devices/" + id, {})
        .then(async (result) => {
          console.log("device detail", result)
          this.device = result.data.data
          this.loadService()
          this.loadGroupEndpoints()
          /** redirect to all lora devices if current project differs from new selected */
          if (this.$router.currentRoute.value.params.projectId != this.device.projectId) {
            this.$router.push({ name: "lora" })
          }

          this.transformationFunction = null
          if (this.device.transformationId) {
            const { data } = await client.path("/transformations/{transformationId}").method("get").create()({
              transformationId: this.device.transformationId
            })
            this.transformationFunction = data.data
          }
        })
        .catch(() => {})
    },
    toggleDropdown() {
      this.openedDropdown ? (this.openedDropdown = false) : (this.openedDropdown = true)
    },
    loadService() {
      axios
        .get(process.env.VUE_APP_API + "/services/" + this.device.custServiceId)
        .then((result) => {
          this.service = result.data.data
        })
        .catch(() => {})
    },
    loadGroupEndpoints() {
      this.groups = []
      this.groupsEndpoints = []
      if (this.device.deviceGroups.length > 0) {
        let counter = 0
        let groupsCount = this.device.deviceGroups.length
        for (var i = 0, len = this.device.deviceGroups.length; i < len; i++) {
          let group = this.device.deviceGroups[i]
          axios
            .get(process.env.VUE_APP_API + "/device-groups/" + group.deviceGroupId)
            .then((result) => {
              this.groups.push(result.data.data)
              counter++
              if (counter == groupsCount) {
                for (var a = 0, len = this.groups.length; a < len; a++) {
                  let loadedGroup = this.groups[a]
                  axios
                    .get(process.env.VUE_APP_API + "/device-groups/" + loadedGroup.deviceGroupId + "/endpoints")
                    .then((result) => {
                      var obj = {
                        group: loadedGroup,
                        endpoints: result.data.data
                      }
                      this.groupsEndpoints.push(obj)
                    })
                    .catch(() => {})
                }
              }
            })
            .catch(() => {})
        }
      }
    },
    toggleEndpoints(group) {
      var index = this.openedGroups.indexOf(group)
      if (this.openedGroups.indexOf(group) > -1) {
        this.openedGroups.splice(index, 1)
      } else {
        this.openedGroups.push(group)
      }
    },
    loadLogs() {
      axios
        .get(process.env.VUE_APP_API + "/audits/devices/" + this.id + "?sort=" + this.sort, {})
        .then((result) => {
          this.allLogs = result.data.data
        })
        .catch(() => {})
    },
    sortBy(sortingParam) {
      let newSortingParam = ""
      this.selectedRows = []
      this.isSelectedAllOnPage = false
      if (this.sort.indexOf(sortingParam) > -1) {
        if (this.sort.substring(2, 3) == "D") {
          newSortingParam = "%2B" + sortingParam
        } else {
          newSortingParam = "%2D" + sortingParam
        }
      } else {
        newSortingParam = "%2D" + sortingParam
      }
      this.sort = newSortingParam
    },
    filteredLogs(logs) {
      this.allLogs = logs
    },
    toggleDeleteDevice(items) {
      if (this.openedDeleteDevice == true) {
        this.openedDeleteDevice = false
        this.deleteText = ""
      } else {
        if (items) {
          this.deleteText = items.length > 1 ? "zarizeniPocet" : items[0].custDeviceName
        }
        this.openedDeleteDevice = true
      }
    },
    async deleteDevice() {
      this.errorsToTranslate = []
      let id = this.device.deviceId
      let notifications = []

      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))

      try {
        await this.mqttStore.deleteDevice(this.device)

        this.$store.commit("modals/setWaitingLoader", "")
        notifications.push({
          text: "notificationDeviceDelete",
          error: false,
          params: {
            deviceId: id,
            custDeviceName: this.device.custDeviceName
          }
        })

        this.$router.push({
          name: "mqttDevices",
          params: {
            customerId: this.selectedCustomerId,
            projectId: this.selectedProjectId,
            notifications: notifications
          }
        })
      } catch (e) {
        const er = [{ errors: [] }]
        let message = e.data?.errors?.[0] || e.message
        er[0].errors.push({
          message: message,
          attribute: {
            deviceId: this.device.deviceId,
            custDeviceName: this.device.custDeviceName
          }
        })
        this.errorsToTranslate = er
        this.openedError = true
        this.$store.commit("modals/setWaitingLoader", "")
      }
    },
    handleTransformUpdated() {
      this.transformKey = Math.random().toString()
    },
    setReloadDM(value) {
      this.reloadDM = false
      this.reloadDM = value
    },
    showMessage(message) {
      this.selectedMessage = message
      this.openedMessageDetail.push("showMessage")
    },
    toggleEditDeviceModal(box) {
      if (this.openedEditDevice.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditDevice = [])
          : this.openedEditDevice.splice(this.openedEditDevice.indexOf(box), 1)
      } else {
        this.openedEditDevice.push(box)
      }
    },
    toggleMoveDeviceModal(box) {
      if (this.openedMoveDevice.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMoveDevice = [])
          : this.openedMoveDevice.splice(this.openedMoveDevice.indexOf(box), 1)
      } else {
        this.openedMoveDevice.push(box)
      }
    },
    toggleShowMessage(box) {
      if (this.openedMessageDetail.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMessageDetail = [])
          : this.openedMessageDetail.splice(this.openedMessageDetail.indexOf(box), 1)
      } else {
        this.openedMessageDetail.push(box)
      }
    },
    toggleSendMessageModal(box) {
      if (box == undefined || this.openedSendMessage.indexOf(box) > -1) {
        box == undefined
          ? (this.openedSendMessage = [])
          : this.openedSendMessage.splice(this.openedSendMessage.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedSendMessage.push(box)
      }
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    async handleDeviceMoved() {
      await this.$router.push({
        name: "mqttDevices",
        params: {
          customerId: this.selectedCustomerId,
          projectId: this.selectedProjectId
        }
      })

      this.clearNotification()
      this.setNotification({
        text: "NOTIFICATION_DEVICE_MOVED",
        error: false,
        params: {
          deviceId: this.deviceId
        }
      })
    },
    async checkSuspendedMessages() {
      const to = new Date().toISOString()
      const from = new Date(new Date() - 31 * 24 * 60 * 60 * 1000).toISOString()
      const upMessages = await axios.get(
        `${process.env.VUE_APP_API}/mqtt/devices/${this.deviceId}/up/messages?from=${from}&to=${to}&limit=1&messageStatus[in]=suspended`,
        {}
      )
      this.suspendedMessagesCount = upMessages.data.metadata.count
    }
  }
}
</script>
